// Call-script variable interpolation. Supports {name} and {{name}} spellings.

/**
 * @param {string} body - Script text with {variables}.
 * @param {object|null} lead
 * @param {object|null} agent - Logged-in agent.
 * @returns {string} Script with known variables replaced; unknown ones are left as typed.
 */
export function fillScript(body, lead, agent) {
  const first = lead?.firstName || '';
  const last = lead?.lastName || '';
  const vars = {
    name: first || 'there',
    first_name: first || 'there',
    firstname: first || 'there',
    last_name: last,
    full_name: [first, last].filter(Boolean).join(' ') || 'there',
    agent: agent?.name || '',
    agent_name: agent?.name || '',
    state: lead?.state || '',
    city: lead?.city || '',
    phone: lead?.phone || '',
    plan: lead?.productInterest || 'plan',
  };
  return String(body || '').replace(/\{\{?\s*([a-z_]+)\s*\}?\}/gi, (m, key) => {
    const v = vars[key.toLowerCase()];
    return v === undefined ? m : v;
  });
}
